import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import useScrollToTop from "@/hooks/useScrollToTop";
import useLangSync from "@/hooks/useLangSync";
import { Outlet } from "react-router-dom";

export default function Layout() {
  useScrollToTop();
  useLangSync();
  return (
    <div className="ag-shell">
      <Header />
      <main className="ag-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
